import Base from 'app/collections/base';
import { fulfillmentUrl } from 'utils/wrappers';
import FulfillmentProduct from 'app/models/fulfillment_product';

import FulfillmentInventory from 'app/collections/fulfillment_inventory';

export default Base.extend({
  model: FulfillmentProduct,
  key: 'products',
  url: fulfillmentUrl('products'),

  initialize(models, { apiModeSelection }) {
    this.apiModeSelection = apiModeSelection;

    this.inventory = new FulfillmentInventory(this.models.map(m => m.get('inventory')), {
      apiModeSelection: apiModeSelection,
    });

    this.listenTo(this.apiModeSelection, 'change', this.filtered);

    this.listenTo(this, 'sync', this.fetchInventory);
    this.listenTo(this.inventory, 'sync', this.updateInventory);
  },

  filtered() {
    this.trigger('filtered')
  },

  searchById(term) {
    const filterType = term.split('_', 1)[0];
    const self = this;

    if (filterType === 'warehouse') {
      // hit inventory api, look up by warehouse
      // this.reset([data]);
      // unimplemented right now
      this.reset();
      this.trigger('sync');
    } else if (filterType === 'prod') {
      new this.model({ id: term }).fetch({
        data: { ...this.apiModeSelection.getParams() },
        success(model) {
          self.reset([model]);
        },
        error() {
          self.reset();
          self.trigger('sync');
        },
      });
    } else {
      this.reset();
      this.trigger('sync');
    }
  },

  paramsForFetch() {
    return {
      ...this.apiModeSelection.getParams(),
      sort: 'title asc',
    };
  },

  parse(response) {
    this.hasMore = response[this.key].length === 10;
    return response[this.key];
  },

  fetchInventory() {
    this.inventory.fetch({ productIds: this.models.map(m => m.get('id')) });
  },

  updateInventory() {
    this.inventory.models.forEach(i => {
      this.models.find(m => m.get('id') === i.get('product_id')).set({
        inventories: i,
      });
    });
  }
});



// WEBPACK FOOTER //
// ./app/collections/fulfillment_products.js